module.exports = __webpack_public_path__ + "img/Inventory.b90368e8.svg";